import React from 'react';

import useSearchQuery from '@shared/v2/hooks/useSearchQuery';

import FlightOptions from '@/components/FlightOptions';
import useDestination from '@/hooks/useDestination';
import usePropertyContent from '@/hooks/usePropertyContent';
import goToCheckout from '@/utils/goToCheckout';
import { useRoomOptionsData } from '@/v2/components/pages/PackageViewV2/contexts/RoomOptionsContext';
import useRooms from '@/v2/components/pages/PackageViewV2/hooks/useRooms';
import { useDestination as v2UseDestination } from '@/v2/contexts/destination';

const FlightOptionsView = () => {
  const { selectedRoomOption } = useRoomOptionsData() || {};

  const { flightOptions, loading } = useRooms();

  const d = useDestination();
  const dV2 = v2UseDestination();
  const destination = d || dV2;

  const propertyContent = usePropertyContent();
  const { searchQuery } = useSearchQuery();

  const { offerId } = searchQuery;

  if (!offerId) return null;

  const offer = selectedRoomOption?.offers?.filter(
    (offer) => offerId === offer.hotelOffer.id,
  )?.[0];

  const onConfirmFlights = ({ segments }) => {
    const { country, travelType } = destination;

    goToCheckout({
      propertyId: propertyContent.id,
      offerId: offer.hotelOffer.id,
      roomTypeId: selectedRoomOption.roomType.id,
      flights: segments,
      searchQuery,
      countryCode: country,
      travelType,
    });
  };

  return (
    <FlightOptions
      loading={loading || !flightOptions}
      flightOptions={flightOptions}
      bestOfferCharges={offer?.charges}
      onConfirmFlights={onConfirmFlights}
    />
  );
};

export default FlightOptionsView;
